export default __webpack_public_path__ + "static/media/146-university.0212db5f.png";